import React from 'react';
import type { CellRenderProps } from '@axiom/ui';
import { IconButton, Layout } from '@axiom/ui';

import type { CandidateDetail } from '../../api/chat-api';
import { AxiomForTalentUtil } from '../../../utils/axiom-for-talent-util';

/** Pulls a candidate's bio down as a document. Nothing to fetch without an id, so nothing is shown. */
export const MatchGridDownloadBio = ({
  data,
}: CellRenderProps<CandidateDetail>) => {
  if (!data.id) return null;

  return (
    <Layout position="center">
      <IconButton
        icon="avatar"
        name={`DOWNLOAD_BIO_BUTTON_${data.id}`}
        onClick={() => {
          AxiomForTalentUtil.downloadBio(data.id);
        }}
        pattern="secondary"
        title="Download Bio"
        variation="minimal"
      />
    </Layout>
  );
};
